<template>
  <section id="choose-stop"
           class="uk-margin-large-top uk-margin-medium-bottom uk-padding-medium uk-padding-remove-horizontal"
  >
    <modal name="loading-stops" width="60%" :height="'auto'" :clickToClose="false">
      <div class="uk-panel uk-padding-large uk-align-center">
        <h3>Lade Register...</h3>
        <p>Wir schauen gerade f&uuml;r Sie nach, in welchen Registern der Orgel Pfeifen aus der von Ihnen gew&auml;hlten Preiskategorie enthalten sind.</p>
      </div>
    </modal>
    <template v-if="organ_stop.list">
      <div class="uk-container uk-container-large">
        <div class="uk-align-center uk-width-1-1 uk-width-2-3@m">
          <h2 class="uk-h2">2. Register ausw&auml;hlen</h2>
          <div v-for="w in organ_work.list" v-bind:key="w.id">

            <h3 class="uk-margin-large-top">{{w.title}}</h3>

            <div class="uk-child-width-1-2@m uk-child-width-1-4@xl" data-uk-grid>
              <div v-for="s in sortedStops(w.id)" v-bind:key="s.id"
                   v-if="s.parentID === w.id && s.children.getTotal > 0">
                <button class="uk-button uk-button-default uk-text-large"
                        v-on:click="setStop(s.id, s.title, s.length)"
                        v-bind:class="isSelected(s.id)"
                  >{{s.title}}&nbsp;{{s.length}}'
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import {mapGetters} from 'vuex'
import EventBus from '../../event-bus'
import {WORKS_QUERY, STOPS_QUERY_SEARCH} from '../../constants/graphql'
import {Power2, TweenMax} from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

import _ from 'lodash'

export default {
  name: 'choose-stop',
  data () {
    return {
      organ_work: {},
      organ_stop: {},
      organ_stop_selector: 'price_ref.amount=-1'
    }
  },
  apollo: {
    organ_work: {
      query: WORKS_QUERY
    },
    organ_stop: {
      query: STOPS_QUERY_SEARCH,
      variables () {
        return {
          hasPrice: this.organ_stop_selector
        }
      },
      skip () {
        return (typeof this.chosenPrice.amount === 'undefined')
      },
      watchLoading (isLoading, countModifier) {
        if (isLoading) {
          this.showModal()
        } else {
          this.hideModal()
          TweenMax.to(window, 2, {scrollTo: '#choose-stop', ease: Power2.easeOut})
        }
      }
    }
  },
  computed: {
    ...mapGetters(['chosenPrice', 'chosenStop'])
  },
  methods: {
    sortedStops () {
      if (typeof this.chosenPrice.amount !== 'undefined') {
        this.organ_stop_selector = 'price_ref.amount=' + this.chosenPrice.amount.toString()
      }
      return _.sortBy(this.organ_stop.list, ['title'])
    },
    setStop (id, title, length) {
      this.$store.dispatch('setStop', {id: id, title: title, length: length})
    },
    isSelected (id) {
      return this.chosenStop.id === id ? 'selected' : 'disabled'
    },
    showModal () {
      this.$modal.show('loading-stops', {
        height: 'auto'
      })
    },
    hideModal () {
      this.$modal.hide('loading-stops')
    }
  },
  watch: {
    chosenPrice (newPrice, oldPrice) {
      this.organ_stop_selector = 'price_ref.amount=' + newPrice.amount.toString()
    }
  },
  mounted () {
    EventBus.$on('HIDE_PIPES', (payload) => {
      this.setStop(undefined, undefined, undefined)
    })
  }
}
</script>
<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";

  #choose-stop {
    .uk-button-default {
      width: 100%;
      white-space: nowrap;
      @media (min-width: $breakpoint-medium) {
        padding: 3px 16px;
      }
      @media (min-width: $breakpoint-large) {
        padding: 3px 20px;
      }
      @media (min-width: $breakpoint-xlarge) {
        padding: 3px 30px;
      }
    }
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/ChooseStop.vue